import { B as R } from "../Body-CmWUG3To.es.js";
import { F as B } from "../FooterLabel-D6A83-PY.es.js";
import { I } from "../Icon-BZlU65ZH.es.js";
import { S as y } from "../StaticIcon-bc8JeCT4.es.js";
import { J as $ } from "../JumpTo-BE59VTN7.es.js";
import { L } from "../Link-BCIoOwB_.es.js";
import { I as E } from "../Image-C_3DjfOa.es.js";
import { P as H } from "../Pill-nKwr2_nH.es.js";
import { R as J } from "../Ribbon-CskQkeY4.es.js";
import { T as h } from "../Title-BVNFHGQY.es.js";
import { C as M } from "../Chips-Cduxcf41.es.js";
import e from "react";
import g from "classnames";
import { useHover as Z } from "react-aria";
import { u as q } from "../DarkModeProvider-xoZXm3ct.es.js";
import { L as K } from "../Loading-nf3RyHcW.es.js";
import '../index.css';const Q = "Card-module__card___zeE7r", U = "Card-module__clickable___tKGrJ", W = "Card-module__dark___t2Cmm", O = "Card-module__indicators___liRfc", X = "Card-module__withLeftImage___9FCPM", Y = "Card-module__cardContent___8AS3H", ee = "Card-module__leftContent___Pubwu", te = "Card-module__withImage___qF2rj", oe = "Card-module__footer___lDeQA", re = "Card-module__footerLabels___ZcVf1", ae = "Card-module__linksContainer___xg1zh", r = {
  card: Q,
  clickable: U,
  dark: W,
  "topSection-left": "Card-module__topSection-left___Ro6bs",
  "topSection-top": "Card-module__topSection-top___GIsud",
  indicators: O,
  withLeftImage: X,
  cardContent: Y,
  leftContent: ee,
  withImage: te,
  "image-top": "Card-module__image-top___V425i",
  "image-left": "Card-module__image-left___hEW6Z",
  footer: oe,
  footerLabels: re,
  linksContainer: ae
};
function i(a, n) {
  return typeof a == "string" || typeof a == "number" || !("type" in a) ? !1 : a.type === n;
}
function b(a, n) {
  const t = a.find((s) => i(s, n));
  if (t)
    return t;
}
const ne = ({
  links: a,
  darkMode: n
}) => /* @__PURE__ */ e.createElement(e.Fragment, null, a.map((t, s) => /* @__PURE__ */ e.createElement(
  L,
  {
    key: `${t.props.iconName}-${s}`,
    ...t.props,
    darkBg: n
  }
))), P = ({
  ribbon: a,
  staticIcon: n,
  icon: t,
  hasImage: s,
  pill: d,
  position: _
}) => /* @__PURE__ */ e.createElement(e.Fragment, null, a, n && !t && !s && /* @__PURE__ */ e.createElement(y, { ...n.props }), d, t && /* @__PURE__ */ e.createElement(I, { ...t.props, overlay: s && _ === "top" })), le = ({
  children: a,
  loading: n = !1,
  position: t = "top",
  darkBg: s = !1,
  onHover: d
}) => {
  const _ = q(), { hoverProps: x, isHovered: A } = Z({
    onHoverChange(o) {
      d && d(o);
    }
  }), l = e.Children.toArray(a), m = b(l, E), f = b(l, h), j = l.find((o) => i(o, R)), z = l.find((o) => i(o, M)), p = l.find(
    (o) => i(o, J)
  ), C = l.find((o) => i(o, H)), w = b(l, I), v = b(
    l,
    y
  ), N = l.filter((o) => i(o, B)).slice(0, 2), u = l.filter(
    (o) => i(o, L)
  ), D = l.find(
    (o) => i(o, $)
  ), k = u[0]?.props?.onClick ?? f?.props?.onClick, G = u[0]?.props?.openInNewTab ?? f?.props?.openInNewTab, V = (o) => {
    G ? window.open(o, "_blank") : window.location.href = o;
  }, T = typeof k == "string" ? () => {
    V(k);
  } : k;
  let S = !1;
  (t === "left" && (p || C) || t === "top" && (p || C || v) && !m) && (S = !0);
  const F = {
    ribbon: p,
    staticIcon: v,
    icon: w,
    hasImage: !!m,
    pill: C,
    position: t
  };
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    /* @__PURE__ */ e.createElement(
      "div",
      {
        ...x,
        className: g([
          r.card,
          T && r.clickable,
          _ && r.dark
        ]),
        onClick: T,
        role: "group",
        "aria-live": "polite",
        ...n ? { "aria-busy": !0 } : { "aria-busy": !1 }
      },
      n ? /* @__PURE__ */ e.createElement(K, null) : /* @__PURE__ */ e.createElement("div", { className: r[`topSection-${t}`] }, t === "top" && /* @__PURE__ */ e.createElement("div", { className: r.indicators }, /* @__PURE__ */ e.createElement(P, { ...F })), m && /* @__PURE__ */ e.createElement("div", { className: r[`image-${t}`] }, /* @__PURE__ */ e.createElement(E, { ...m.props, position: t })), t === "left" && /* @__PURE__ */ e.createElement(
        "div",
        {
          className: g(
            r.indicators,
            m && r.withLeftImage
          )
        },
        /* @__PURE__ */ e.createElement(P, { ...F })
      ), /* @__PURE__ */ e.createElement(
        "div",
        {
          className: g(
            r.cardContent,
            t === "left" && r.leftContent,
            m && r.withImage
          )
        },
        f && /* @__PURE__ */ e.createElement(
          h,
          {
            ...f.props,
            nextToIcon: !!w && !m && !p && !C,
            addHeaderSpacer: S,
            isHovered: A
          }
        ),
        j,
        z,
        /* @__PURE__ */ e.createElement("div", { className: r.footer }, !!N.length && /* @__PURE__ */ e.createElement("div", { className: r.footerLabels }, N), !!u.length && /* @__PURE__ */ e.createElement("div", { className: r.linksContainer }, /* @__PURE__ */ e.createElement(ne, { links: u, darkMode: s || _ })))
      )),
      D
    )
  );
}, c = le;
c.Body = R;
c.FooterLabel = B;
c.Icon = I;
c.StaticIcon = y;
c.JumpTo = $;
c.Link = L;
c.Image = E;
c.Pill = H;
c.Ribbon = J;
c.Title = h;
c.Chips = M;
export {
  c as default
};
